module.exports = __webpack_public_path__ + "img/GDC.f759a89f.svg";